import { render, staticRenderFns } from "./AssuranceRevenus.vue?vue&type=template&id=cd0f59b4&"
import script from "./AssuranceRevenus.vue?vue&type=script&lang=js&"
export * from "./AssuranceRevenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports